import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        planningGroup: '='
    },
    template: `
        <div class="alert alert-info apg-generation-progress" ng-if="vm.isStarted() && vm.isActive()">
            <div class="apg-generation-progress-status">
                <div class="loader01"></div>
                <p ng-if="vm.progress.status === vm.STATUS.QUEUED">
                    {{ 'planningGroup.generation_progress_queued' | translate }}
                </p>
                <p ng-if="vm.progress.status === vm.STATUS.RUNNING && !vm.isCounting()">
                    {{ 'planningGroup.generation_progress_starting' | translate:{ userCount: vm.progress.userCount } }}
                </p>
                <p ng-if="vm.isCounting()">
                    {{ 'planningGroup.generation_progress_running' | translate:{
                        enrolledCount: vm.progress.enrolledCount,
                        userCount: vm.progress.userCount
                    } }}
                </p>
            </div>
            <div class="progress01 margt" ng-if="vm.isCounting()">
                <span style="width: {{ vm.getPercent() }}%">{{ vm.getPercent() }}%</span>
            </div>
        </div>
        <div class="alert alert-danger apg-generation-progress"
            ng-if="vm.isStarted() && vm.progress.status === vm.STATUS.FAILED"
        >
            {{ 'planningGroup.generation_progress_failed' | translate }}
        </div>
    `
})
export default class {
    constructor ($scope, $timeout, $translate, toastr, AutomatedPlanningGroupResource,
                 AUTOMATED_PLANNING_GROUP_STATUS_ENUM, AUTOMATED_PLANNING_GROUP_GENERATION_STATUS_ENUM) {
        this.$scope = $scope;
        this.$timeout = $timeout;
        this.$translate = $translate;
        this.toastr = toastr;
        this.AutomatedPlanningGroupResource = AutomatedPlanningGroupResource;
        this.AUTOMATED_PLANNING_GROUP_STATUS_ENUM = AUTOMATED_PLANNING_GROUP_STATUS_ENUM;
        this.STATUS = AUTOMATED_PLANNING_GROUP_GENERATION_STATUS_ENUM.KEYS;
    }

    /**
     * How often the progress of a queued or running enrollment is asked for, in milliseconds
     *
     * @returns {number}
     */
    get POLL_INTERVAL () {
        return 3000;
    }

    $onInit () {
        this.progress = null;
        this.loading = false;
        this.timer = null;
        this.destroyed = false;
        this.followsStart = false;

        // a group that is started, also by a save on this page, enrolls its members in a queue job
        this.$scope.$watch(() => this.planningGroup && this.planningGroup.status, (status, previousStatus) => {
            if (status === this.AUTOMATED_PLANNING_GROUP_STATUS_ENUM.KEYS.STARTED) {
                // a start on this page is confirmed even when its run ends before the first answer, as the run
                // of a group whose members are all enrolled already does
                this.followsStart = previousStatus !== undefined && previousStatus !== status;
                this.fetch();
            }
            else {
                // a group that is not started shows no run, an enrollment already going on still ends as always
                this.$timeout.cancel(this.timer);
            }
        });
        this.$scope.$on('$destroy', () => {
            this.destroyed = true;
            this.$timeout.cancel(this.timer);
        });
    }

    fetch () {
        if (this.loading || this.destroyed) {
            return;
        }
        this.$timeout.cancel(this.timer);
        this.loading = true;
        this.AutomatedPlanningGroupResource.generationProgress({ id: this.planningGroup.id }).$promise
            .then((progress) => {
                const wasActive = this.isActive();
                this.progress = progress;
                if ((wasActive || this.followsStart) && progress.status === this.STATUS.FINISHED) {
                    this.toastr.success(this.$translate.instant('planningGroup.generation_progress_finished'));
                    this.$scope.$emit('planning-group:generation-finished');
                }
                if (!this.isActive()) {
                    this.followsStart = false;
                }
            })
            .finally(() => {
                this.loading = false;
                // a poll that failed is asked again while the run was going on, the run does not depend on it
                if (this.isStarted() && this.isActive() && !this.destroyed) {
                    this.timer = this.$timeout(() => this.fetch(), this.POLL_INTERVAL);
                }
            })
        ;
    }

    isStarted () {
        return Boolean(this.planningGroup)
            && this.planningGroup.status === this.AUTOMATED_PLANNING_GROUP_STATUS_ENUM.KEYS.STARTED;
    }

    isActive () {
        return Boolean(this.progress)
            && (this.progress.status === this.STATUS.QUEUED || this.progress.status === this.STATUS.RUNNING);
    }

    /**
     * The count shows once members are enrolled: a group with a TEST training enrolls a new occurrence in one
     * transaction, so until its end there is nothing to count
     */
    isCounting () {
        return Boolean(this.progress)
            && this.progress.status === this.STATUS.RUNNING
            && this.progress.enrolledCount > 0;
    }

    getPercent () {
        if (!this.progress || !this.progress.userCount) {
            return 0;
        }

        return Math.floor(this.progress.enrolledCount * 100 / this.progress.userCount);
    }
}



// WEBPACK FOOTER //
// ./src/app/components/courses/courses/edit/occurrence/automated/planningGroup/generationProgress/index.js